import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "#fff",
  viewBox: "-5 -5 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M35.512 17.978a2 2 0 0 0-1.878-2.688h-4.428V10a2 2 0 0 0-2-2h-3.757V2a2 2 0 0 0-2-2h-5.332a2 2 0 0 0-2 2v6h-3.756a2 2 0 0 0-2 2v5.289H3.934a2 2 0 0 0-1.878 2.688s5.577 15.102 5.677 15.24a5.2 5.2 0 0 1-1.846.351 2 2 0 0 0 0 4c2.333 0 4.594-.91 6.449-2.554 1.854 1.644 4.116 2.554 6.448 2.554 2.331 0 4.593-.91 6.447-2.554 1.854 1.644 4.115 2.554 6.448 2.554a2 2 0 0 0 0-4c-.631 0-1.25-.123-1.846-.351.1-.138 5.679-15.239 5.679-15.239M25.206 12v3.289h-4.424V12zm-12.844 0h4.423v3.289h-4.423z" }, null, -1)
  ])))
}
export default { render: render }